import { isDefined } from '@angular/compiler/src/util';
import { isString } from 'util';
import { session_keys } from '../enums/ui.enums';
import { User } from '../models/user.model';
import { Authetication } from '../models';

export class UIUtil {
  public static stringHasValue(value: string): boolean {
    return isDefined(value) && (isString(value) ? value.trim().length > 0 : true);
  }

  public static savePrivateData(key, jsonData) {
    localStorage.setItem(key, JSON.stringify(jsonData));
    return true;
  }

  public static getPrivateData(key): Authetication {
    const data = JSON.parse(localStorage.getItem(key)) as Authetication;
    if (data) {
      return data;
    } else {
      const d: Authetication = new Authetication();
      return d;
    }
  }

  public static objectKeyCount(model): number {
    return Object.keys(model).length;
  }

  public static strongPwd(pwd) {
    // const hasNumber = /\d/.test(pwd);
    // const hasUpper = /[A-Z]/.test(pwd);
    // const hasLower = /[a-z]/.test(pwd);
    // const lengthCapacity = pwd.length >= 8 ? true : false;
    const wholeTest = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/.test(pwd);
    // console.log('Num, Upp, Low', hasNumber, hasUpper, hasLower);
    const valid = wholeTest;
    if (!valid) {
      return false;
    }
    return true;
  }
}
